import type { UserManagerSettings } from 'oidc-client-ts';

const SIGNIN_REDIRECT_URL_KEY = 'signin_redirect_url';

const userManagerSettings = {
  authority: `${import.meta.env.VITE_APP_API_URL}/oauth2`,
  client_id: import.meta.env.VITE_APP_ENV === 'localhost' ? 'bp-pro-dev' : 'bp-pro-accounts-web',
  post_logout_redirect_uri: import.meta.env.VITE_APP_EXCHANGE_URL,
  redirect_uri: `${import.meta.env.VITE_APP_URL}/auth-callback`,
  refreshTokenAllowedScope: '',
  scope: 'openid email profile',
} satisfies UserManagerSettings;

export { SIGNIN_REDIRECT_URL_KEY, userManagerSettings };
